import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "marker-library-item",
  templateUrl: "./marker-library-item.component.html",
  styleUrls: ["./marker-library-item.component.scss"],
})
export class MarkerLibraryItemComponent implements OnInit {
  @Input() marker;

  constructor() {}

  ngOnInit(): void {}

  onDragStart(event: DragEvent) {
    event.dataTransfer.setData(
      "text/markers",
      JSON.stringify({ type: this.marker.type, inOut: this.marker.inOut }),
    );
  }
}
